import { Button } from '@/components/Button';
import {
  MdLinkOff,
  MdAdd,
  MdPerson,
  MdEdit,
  MdDelete,
  MdNewLabel,
  MdLabelOff,
} from 'react-icons/md';
import BulkActionsPopover, {
  type BulkActionType,
  type BulkActionItem,
} from '@/components/BulkActionsPopover';

export type { BulkActionType };

interface Props {
  selectedCount: number;
  onDeselectAll: () => void;
  onSuggestJobPosts: () => void;
  onBulkAction: (action: BulkActionType) => void;
  /** 一括削除を表示するか（組織の管理者のみ true） */
  canBulkDelete?: boolean;
}

const bulkActionItems: (BulkActionItem & { requiresDelete?: boolean })[] = [
  {
    action: 'changeOrganizationUser',
    label: '担当者変更',
    icon: <MdPerson className="size-icon-xs" />,
  },
  { action: 'addTag', label: 'タグを追加', icon: <MdNewLabel className="size-icon-xs" /> },
  {
    action: 'removeTag',
    label: 'タグを解除',
    icon: <MdLabelOff className="size-icon-xs" />,
  },
  { action: 'updateData', label: 'データ更新', icon: <MdEdit className="size-icon-xs" /> },
  {
    action: 'deleteData',
    label: 'データ削除',
    icon: <MdDelete className="size-icon-xs" />,
    requiresDelete: true,
  },
];

export default function CandidatesSelectionBar({
  selectedCount,
  onDeselectAll,
  onSuggestJobPosts,
  onBulkAction,
  canBulkDelete = false,
}: Props) {
  const visibleBulkActionItems = bulkActionItems.filter(
    (item) => !item.requiresDelete || canBulkDelete
  );

  if (selectedCount === 0) return null;

  return (
    <div className="sticky bottom-0 z-50 flex items-center justify-between gap-2 rounded-t bg-white px-6 py-4 shadow-layer3">
      {/* 左側: 選択件数 + 選択解除 */}
      <div className="flex items-baseline gap-1">
        <span className="text-lg font-bold">{selectedCount}件</span>
        <span className="mr-1 text-sm">選択中</span>
        <Button color="secondary" size="md" onClick={onDeselectAll}>
          <MdLinkOff className="size-icon-sm" />
          選択解除
        </Button>
      </div>

      {/* 右側: 求人の提案 + 一括操作ドロップダウン */}
      <div className="flex items-center gap-2">
        <Button color="secondary" size="md" onClick={onSuggestJobPosts}>
          <MdAdd className="size-icon-sm" />
          求人の提案
        </Button>

        <BulkActionsPopover items={visibleBulkActionItems} onAction={onBulkAction} />
      </div>
    </div>
  );
}
